



















































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import moment from "moment";
import Gailan from "./shijuangailan.vue";
import {
  GetMoniTimu$,
  PostMoniSave$,
  CheckMoniResult$,
} from "@/request/shezhenjiaoxue";
import Danxuan from "./danxuan.vue";
import Duoxuan from "./duoxuan.vue";
import CompleteDialog from "./complete.vue";
@Component({
  components: {
    Gailan,
    Danxuan,
    Duoxuan,
    CompleteDialog,
  },
})
export default class SzsxMoni extends Vue {
  private test: any = {
    create_time: "",
  };
  private exam: any = {};
  private filters: any = {
    current_page: 1,
    total_count: 0,
    total_page: 0,
    page_count: 5,
  };
  private leftTime: number = 30;
  private ifShowResult: boolean = false;
  private result: any = {};
  private interval: any = {};
  private get answers() {
    return this.$store.state.moniAnswers;
  }
  /**
   * @description 获得试卷详情
   */
  private fetchTestDetail() {
    GetMoniTimu$(this).then((data: any) => {
      console.log(data);
      this.$set(this, "test", data);
      this.filters.total_count = data.questions.length;
      data.questions.forEach((question: any) => {
        question["reply"] = [];
      });
      this.filters.total_page = 1;
      // this.answers = data.questions;
      this.$store.commit("updateMoniAnswers", data["questions"]);
      let radioCount = 0;
      let radioScore = 0;
      let multiCount = 0;
      let multiScore = 0;
      let totalCount = 0;
      let totalScore = 0;
      data.questions.forEach((question: any) => {
        if (question["题目类型"] === "单选") {
          radioCount++;
          radioScore += question["分数"];
        }
        if (question["题目类型"] === "多选") {
          multiCount++;
          multiScore += question["分数"];
        }
        totalCount++;
        totalScore += question["分数"];
      });
      this.test["单选题数量"] = radioCount;
      this.test["单选题分数"] = radioScore;
      this.test["多选题数量"] = multiCount;
      this.test["多选题分数"] = multiScore;
      this.test["题目数量"] = totalCount;
      this.test["总分"] = totalScore;
    });
    // GetExamAnswerDetail$(this, { params: { exam_id: this.exam.exam_id } }).then(
    //   (data: any) => {
    //     // console.log(data);
    //     this.$set(this, "answers", _.cloneDeep(data["questions"]));
    //   }
    // );
  }
  /**
   * @description 倒计时
   */
  private countDown() {
    this.interval = setInterval(() => {
      this.leftTime--;
      if (this.leftTime <= 0) {
        clearInterval(this.interval);
        this.save().then((data) => {
          this.showComplete(data);
        });
      }
    }, 1000 * 60);
  }

  /**
   * @description 获得学生信息
   */
  private fetchStudentDetail() {
    // const params: any = {
    //   params: {
    //     exam_id: this.exam.exam_id,
    //   },
    // };
    // GetStudentInfo$(this, params).then((data: any) => {
    //   this.$set(this, "student", data);
    // });
  }
  /**
   * @description 单选选中了一项
   */
  private danxuanSelectOne(answerIndex, questionIndex) {
    const targetIndex =
      questionIndex +
      (this.filters["current_page"] - 1) * this.filters.page_count;
    // this.$set(this.answers[targetIndex], "reply", [answerIndex]);
    const tempAnswers = this.answers;
    tempAnswers[targetIndex]["reply"] = [answerIndex];
    tempAnswers[targetIndex]["is_reply"] = true;
    this.$store.commit("updateMoniAnswers", tempAnswers);
    // console.log(this.answers[targetIndex]);
    this.$forceUpdate();
  }
  /**
   * @description 多选选中了一项
   */
  private duoxuanSelectOne(answerIndex, questionIndex) {
    const targetIndex =
      questionIndex +
      (this.filters["current_page"] - 1) * this.filters.page_count;
    const inx = this.answers[targetIndex]["reply"].indexOf(answerIndex);
    if (inx === -1) {
      this.answers[targetIndex]["reply"].push(answerIndex);
      this.answers[targetIndex]["is_reply"] = true;
      this.$store.commit("updateMoniAnswers", this.answers);
    } else {
      this.answers[targetIndex]["reply"].splice(inx, 1);
      if (this.answers[targetIndex]["reply"].length > 0) {
        this.answers[targetIndex]["is_reply"] = true;
      } else {
        this.answers[targetIndex]["is_reply"] = false;
      }
      this.$store.commit("updateMoniAnswers", this.answers);
    }
    this.$forceUpdate();
  }
  /**
   * @description 上一页
   */
  private prev() {
    // this.fanye().then(() => {
    //   this.filters.current_page--;
    //   this.fetchTestDetail();
    // });
  }
  /**
   * @description 下一页
   */
  private next() {
    // this.fanye().then(() => {
    //   this.filters.current_page++;
    //   this.fetchTestDetail();
    // });
  }
  /**
   * @description 跳转到某题目的页面
   */
  private jumpTo(index) {
    // const target = Math.ceil((index + 1) / this.filters.page_count);
    // if (target === this.filters.current_page) {
    //   return;
    // }
    // this.fanye().then(() => {
    //   this.filters.current_page = target;
    //   this.fetchTestDetail();
    // });
  }
  /**
   * @description 翻页临时保存答案
   */
  private fanye() {
    // return new Promise((resolve, reject) => {
    //   const params: any = {
    //     exam_id: this.exam.exam_id,
    //     replies: this.answers,
    //     is_done: false,
    //   };
    //   FinishExam$(this, params)
    //     .then((data: any) => {
    //       resolve();
    //     })
    //     .catch(() => {
    //       reject();
    //     });
    // });
  }
  /**
   * @description 交卷
   */
  private save() {
    return new Promise((resolve, reject) => {
      const params: any = {
        moni_id: this.test.moni_id,
        replies: this.answers,
        is_done: true,
      };
      PostMoniSave$(this, params)
        .then((data: any) => {
          resolve(data);
        })
        .catch(() => {
          reject();
        });
    });
  }
  /**
   * @description 提前交卷
   */
  private aheadSave() {
    this.$confirm("请认真检查后再提交，提交后将无法修改！", {
      title: "确认提前交卷？",
      cancelButtonText: "再检查检查",
      confirmButtonText: "我要交卷",
    })
      .then(() => {
        this.save().then((data) => {
          this.showComplete(data);
        });
      })
      .catch(() => {
        console.log(this.test);
      });
  }
  /**
   * @description 展示完成
   */
  private showComplete(d) {
    CheckMoniResult$(this, { params: { moni_id: this.test.moni_id } }).then(
      (data: any) => {
        console.log(data);
        data["总分"] = this.test["总分"];
        data["题目数量"] = this.test["题目数量"];
        data["答对"] = d["right_count"];
        data["答错"] = d["wrong_count"];
        this.$set(this, "result", _.cloneDeep(data));
        this.ifShowResult = true;
      }
    );
  }
  /**
   * @description 离开页面前提示
   */
  private beforeRouteLeave(to, from, next) {
    if (this.result.moni_id) {
      next(true);
    } else {
      this.$confirm(
        "离开当前页面将直接提交试卷，不可返回修改，确定要离开嘛？",
        {
          title: "温馨提示",
          cancelButtonText: "还要答题",
          confirmButtonText: "我要交卷",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          closeOnHashChange: false,
        }
      )
        .then(() => {
          this.save()
            .then(() => {
              next(true);
            })
            .catch(() => {
              next(false);
            });
        })
        .catch(() => {
          next(false);
        });
    }
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchTestDetail();
    this.fetchStudentDetail();
  }
  /**
   * @description 销毁定时器
   */
  private destroyed() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}
